/* eslint-disable */

export const UPDATE_ALL_STATUS_CONSTANTS = {
    UPDATE_ALL_STATUS_REQUEST: 'UPDATE_ALL_STATUS_REQUEST',
    UPDATE_ALL_STATUS_SUCCESS: 'UPDATE_ALL_STATUS_SUCCESS',
    UPDATE_ALL_STATUS_FAILURE: 'UPDATE_ALL_STATUS_FAILURE',
};
